'use strict';

var React = require('react');

var useForceUpdateRef = function () {
    var elementRef = React.useRef();
    var _a = React.useState(false), setElementCreated = _a[1];
    var setElementRef = function (element) {
        elementRef.current = element;
        setElementCreated(true);
    };
    return [elementRef.current, setElementRef];
};

exports.useForceUpdateRef = useForceUpdateRef;
//# sourceMappingURL=useForceUpdateRef-6d1ca28f.js.map
